import { format } from "date-fns";
import { ActivityTable } from "src/components/ui/ActivityTable";
import { QualityEventAuditEntry } from "src/types/quality-events";
import { getUserDisplayName } from "src/utils/user";
import { z } from "zod";

const auditValueChangeSchema = z.object({ old: z.unknown(), new: z.unknown() });

const auditActionLabels: Record<string, string> = {
  INSERT: "Created record",
  UPDATE: "Updated record",
  DELETE: "Deleted record",
};

export const QualityEventActivityTable = ({
  entries,
}: {
  entries: QualityEventAuditEntry[];
}) => (
  <ActivityTable
    entries={entries}
    getRow={(entry) => {
      const changes = Object.fromEntries(
        Object.entries(entry.changes).flatMap(([key, value]) => {
          if (key.startsWith("_")) return [];
          const parsed = auditValueChangeSchema.safeParse(value);
          return parsed.success ? [[key, parsed.data]] : [];
        })
      );
      const occurredAt = new Date(entry.occurredAt);
      return {
        id: entry.id,
        action: auditActionLabels[entry.action] ?? "Updated record",
        actor: entry.actorUser
          ? getUserDisplayName(entry.actorUser)
          : entry.actorType === "SYSTEM"
            ? "System"
            : "Organization member",
        date: format(occurredAt, "yyyy-MM-dd"),
        time: format(occurredAt, "HH:mm"),
        changes,
      };
    }}
  />
);
